import React from 'react'
import { SectionHeader } from '@/components/molecules/SectionHeader'
import { CaseStudySection, CaseStudy } from '@/components/organisms/CaseStudySection'
import { CaseStudySectionV2, CaseStudyV2 } from '@/components/organisms/CaseStudySectionV2'
import './CaseStudiesSection.css'

import properrLogo from '@/assets/properr_logo.png'
import triptureLogo from '@/assets/tripture_logo.png'
import mulkiLogo from '@/assets/mulki_logo.png'
import workskillsLogo from '@/assets/workskills_logo.png'
import workskillsSaasImage from '@/assets/workskills_saas_dashboard.png'
import workskillsStudentsImage from '@/assets/workskills_students_dashboard.png'
import triptureDashboardImage from '@/assets/tripture_dashboard.jpg'
import triptureAllScreens from '@/assets/tripture_all_screens.png'
import properrAllScreens from '@/assets/properr_all_screens.png'
import workskillsInternsAllScreens from '@/assets/workskills_interns_all_screens.png'
import mulkiSurfClubAllScreens from '@/assets/mulki_surf_club_all_screens.png'

export interface CaseStudiesSectionProps {
  className?: string
  id?: string
}

const categories = [
  'Ed-Tech',
  'Real state',
  'Digital Marketing',
  'Hospitality & Tourism',
]

const caseStudies: CaseStudy[] = [
  {
    companyName: 'Workskills - Performance management software',
    headline: 'SaaS increasing team efficiency ‐ 40%↑↑ ',
    tags: [' SaaS', '0 ‐ 1 Product', 'Team Management', 'Web app', 'B2B', 'Gamification'],
    logoUrl: workskillsLogo,
    images: [workskillsSaasImage],
  },
  {
    companyName: 'Tripture ‐ Luxury stays',
    headline: 'Creating MVP & Re-positioning the brand',
    tags: [' 0 ‐ 1 Product', 'Luxury Stays', 'Catering Experiences', 'Workcations', 'Fun', 'Simplified pricing', 'Interaction Design'],
    logoUrl: triptureLogo,
    images: [triptureDashboardImage],
    cardClassName: 'case-study-card--tripture',
  },
  {
    companyName: 'Workskills ‐ Performance management software',
    headline: 'Empowering 40k students in learning & project completion',
    tags: [' Learning Platform', 'Web app', 'B2C', 'Gamification', 'Scalable'],
    logoUrl: workskillsLogo,
    images: [workskillsStudentsImage],
  },
]

const caseStudiesV2: CaseStudyV2[] = [
  {
    companyName: 'WorkSkills ‐ Trainity internship landing page',
    headline: 'For hiring interns',
    logoUrl: workskillsLogo,
    imageUrl: workskillsInternsAllScreens,
    tags: [
      { label: 'Learning Platform' },
      { label: 'Web app' }, // Icon can be added later via iconUrl property
      { label: 'Accountability' },
      { label: 'Gamification' },
    ],
    achievements: [
      'Gaining trust of the students.',
      'Building anticipation by showing possible growth.',
      'Increased perceived value of the property by using anchoring. Compared the benefits with residential & commercial properties.',
      'Designed multiple financing options based on the different financing problems faced by users. ',
    ],
  },
  {
    companyName: 'Tripture ‐ Luxury property buying',
    headline: 'Generating leads for luxury property',
    logoUrl: triptureLogo,
    imageUrl: triptureAllScreens,
    cardClassName: 'case-study-card-v2--luxury-leads',
    tags: [
      { label: 'Design' },
      { label: 'Responsive' }, // Icon can be added later via iconUrl property
      { label: 'Working prototype' },
      { label: 'B2C' },
    ],
    achievements: [
      'Increased user trust through statistics.',
      'Innovative pricing design to understand market inclination towards pricing.',
      'Increased perceived value of the property by using anchoring. Compared the benefits with residential & commercial properties.',
      'Designed multiple financing options based on the different financing problems faced by users.',
    ],

  },
  {
    companyName: 'Properr',
    headline: 'Increasing the marketing leads',
    logoUrl: properrLogo,
    imageUrl: properrAllScreens,
    tags: [
      { label: 'Design' },
      { label: 'Development' }, // Icon can be added later via iconUrl property
      { label: 'Trust building' },
      { label: 'Gamification' },
    ],
    achievements: [
      'Increased user trust through statistics.',
      'Innovative pricing design to understand market inclination towards pricing.',
      'Increased perceived value of the property by using anchoring. Compared the benefits with residential & commercial properties.',
      'Designed multiple financing options based on the different financing problems faced by users.',
    ],

  },
  {
    companyName: 'Mulki Surf Club',
    headline: 'Repositioning the brand for higher tickets',
    logoUrl: mulkiLogo,
    imageUrl: mulkiSurfClubAllScreens,
    tags: [
      { label: 'Learning Platform' },
      { label: 'Web app' }, // Icon can be added later via iconUrl property
      { label: 'Accountability' },
      { label: 'Gamification' },
    ],
    achievements: [
      'Increased user trust through statistics.',
      'Innovative pricing design to understand market inclination towards pricing.',
      'Increased perceived value of the property by using anchoring. Compared the benefits with residential & commercial properties.',
      'Designed multiple financing options based on the different financing problems faced by users.',
    ],

  }
]

export const CaseStudiesSection: React.FC<CaseStudiesSectionProps> = ({
  className = '',
  id,
}) => {
  return (
    <section id={id} className={`case-studies-section ${className}`}>
      <SectionHeader title="Our Work" chips={categories} />
      {caseStudies.map((caseStudy, index) => (
        <CaseStudySection key={index} caseStudy={caseStudy} />
      ))}
      {caseStudiesV2.map((caseStudiesV2, index) =>
        (<CaseStudySectionV2 key={index} caseStudyV2={caseStudiesV2} />))}
    </section>
  )
}
